import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Eye, Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminOnlyPreview({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-20">
        <Loader2 className="w-7 h-7 animate-spin text-[#e11d48]" />
      </div>
    );
  }

  if (user?.kind === "customer") {
    return <Navigate to="/" replace />;
  }

  if (user?.kind !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-20">
        <div className="w-full max-w-lg bg-[#0a0a0c] border border-white/10 rounded-3xl p-8 md:p-10 text-center">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-[#e11d48]/15 flex items-center justify-center mb-6">
            <Lock className="w-6 h-6 text-[#e11d48]" />
          </div>
          <div className="inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-[#e11d48] mb-3">
            <Eye className="w-3.5 h-3.5" /> Private preview
          </div>
          <h1 className="font-[Outfit] text-3xl font-bold mb-3">Khusus pemilik website</h1>
          <p className="text-sm text-zinc-400 leading-relaxed mb-8">
            Halaman preview ini belum tersedia untuk pengunjung. Masuk dengan akun admin untuk melihatnya.
          </p>
          <Link
            to="/admin/login"
            state={{ from: location.pathname }}
            className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#e11d48] hover:bg-[#be123c] font-semibold transition-colors"
          >
            Masuk sebagai admin
          </Link>
        </div>
      </div>
    );
  }

  return children;
}
